import React from 'react';
import { Box, Container, Typography, Grid, IconButton, Link as MuiLink } from '@mui/material';
import { PhoneIphone, Email, Phone, Room } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, #1e4044 0%, #0a2023 100%)',
        color: '#fff',
        pt: 6,
        pb: 3,
      }}
    >
      <Container maxWidth={false} sx={{px: { xs: 2, sm: 6, md: 12 } }}>
        <Grid container spacing={{ xs: 3, sm: 4, md: 34 }}>
          {/* --- Section 1 : Logo + description --- */}
          <Grid >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontFamily: "'Poppins', sans-serif",
                color: '#35E3C8',
              }}
            >
              SPEEDY Transport & Logistics
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255,255,255,0.8)',
                lineHeight: 1.8,
                maxWidth: 320,
              }}
            >
              {t('footer.description')}
            </Typography>
          </Grid>

          {/* --- Section 2 : Liens rapides --- */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
                fontSize: '1rem',
                color: '#35E3C8',
              }}
            >
              {t('footer.linksTitle')}
            </Typography>
            {[
              { label: t('nav.home'), path: '/' },
              { label: t('nav.about'), path: '/about' },
              { label: t('nav.contact'), path: '/contact' },
              { label: t('nav.customerArea'), path: '/customer-area' },
            ].map((item, index) => (
              <Typography key={index} sx={{ mb: 1 }}>
                <MuiLink
                  component={Link}
                  to={item.path}
                  underline="none"
                  sx={{
                    color: 'rgba(255,255,255,0.8)',
                    '&:hover': { color: '#35E3C8' },
                  }}
                >
                  {item.label}
                </MuiLink>
              </Typography>
            ))}
          </Grid>

          {/* --- Section 3 : Coordonnées --- */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
                fontSize: '1rem',
                color: '#35E3C8',
              }}
            >
              {t('footer.contactTitle')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Email sx={{ mr: 1, color: '#35E3C8' }} />
              <Typography variant="body2">contact@speedytl.com</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
  <PhoneIphone sx={{ mr: 1, color: '#35E3C8' }} />
  <Typography variant="body2">+212 6 61 51 92 91</Typography>
</Box>

{/* ✅ Fixe */}
<Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
  <Phone sx={{ mr: 1, color: '#35E3C8' }} />
  <Typography variant="body2">+212 537 37 14 61</Typography>
</Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <Room sx={{ mr: 1, color: '#35E3C8' }} />
              <Typography variant="body2">{t('footer.address')}</Typography>
            </Box>
          </Grid>
        </Grid>

        {/* --- Ligne de copyright --- */}
        <Box
          sx={{
            borderTop: '1px solid rgba(255,255,255,0.2)',
            mt: 4,
            pt: 2,
            textAlign: 'center',
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.9rem',
          }}
        >
          © {new Date().getFullYear()} SPEEDY Transport & Logistics — {t('footer.rights')}
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
